import Doodle from "./Doodle";
import Link from "next/link";
import type { BlockForm } from "@/form/components/form/modules";

export const CampaignGridItem = ({
  campaign,
  feature = false,
}: {
  campaign: {
    type: "FORM";
    id: string;
    count: string;
    pageView: number;
    create_time: string;
    form: {
      blocks: any[];
    };
  };
  feature?: boolean;
}) => {
  const name = campaign.form.blocks.find((block) => {
    return block.id === "title";
  })?.title;
  const reward = campaign.form.blocks.find((block) => {
    return block.id === "reward";
  })?.type;
  return (
    <Link href={`/forms/${campaign.id}`}>
      <div
        className=" flex flex-col justify-between rounded-sm bg-bgv text-dark1 cursor-pointer"
        style={{
          filter: "drop-shadow(15px 4px 40px rgba(0, 0, 0, 0.1))",
        }}
      >
        <div className={"flex flex-col justify-between"}>
          <div
            className={`relative overflow-hidden ${
              feature ? "h-[235px]" : "h-[96px]"
            }`}
          >
            <Doodle
              seed={name}
              rule={`
            @grid: @p(3,4,5) / 87vmin;
:container {
  gap: 4px;
}
transform: rotate(@p(0, 90, 180, 270)deg);
background-image: @doodle(
  @grid: @p(1, 2, 3) / 100%;
  :container {
    gap: 4px;
  }
  transform: rotate(@p(0, 90, 180, 270)deg);
  background:
    @m(@r4, (radial-gradient(circle at @pn(0, 100, 100, 0)% @pn(0, 100, 0, 100)%, @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(35.36% - 2px), #000 calc(35.36% - 1.5px), #000 calc(35.36% + 2px), transparent calc(35.36% + 2.5px)))),
    linear-gradient(@p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC), @lp);
  @random(0.2) {
    background:
      linear-gradient(@p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(50% - 2px), #000 calc(50% - 1.5px), #000 calc(50% + 2px), @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(50% + 2.5px));
  }
  @random(0.2) {
    background:
      @m(@r2, (radial-gradient(circle at @pn(0, 100)% 50%, @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(44.3% - 2px), #000 calc(44.3% - 1.5px), #000 calc(44.3% + 2px), transparent calc(44.3% + 2.5px)))),
      linear-gradient(@p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC), @lp);
  }
  @random(0.2) {
    background:
      radial-gradient(circle at 0 50%, @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(44.3% - 2px), #000 calc(44.3% - 1.5px), #000 calc(44.3% + 2px), transparent calc(44.3% + 2.5px)),
      radial-gradient(circle at 100% @p(0, 100%), @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(35.36% - 2px), #000 calc(35.36% - 1.5px), #000 calc(35.36% + 2px), transparent calc(35.36% + 2.5px)),
      linear-gradient(@p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC), @lp);
  }
  @random(0.2) {
    --color: @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC);
    background:
      @m(2, (linear-gradient(@pn(180, 90)deg, @pn(transparent, var(--color)) calc(100% - 4px), #000 calc(100% - 4px)) no-repeat 0 0 / calc(50% + 2px) calc(50% + 2px))),
      @p(radial-gradient(circle at 0 0, @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(35.36% - 2px), #000 calc(35.36% - 1.5px), #000 calc(35.36% + 2px), transparent calc(35.36% + 2.5px)), linear-gradient(@m2(transparent))),
      linear-gradient(@p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC), @lp);
  }
);
              `}
            ></Doodle>
          </div>

          <div
            id="card-content"
            className={
              feature
                ? " py-2 h-20 rounded-b-md px-2 font-bold text-dark1 bg-[#292939]/70"
                : " my-2 rounded-md px-2  text-dark1"
            }
            // style={{justifyContent:feature?"space-between":""}}
          >
            <div className="flex h-full flex-col justify-between">
              <div className="flex flex-col">
                <div
                  className={`font-bold ${
                    feature ? "text-white" : "text-dark1"
                  }`}
                >
                  {name}
                </div>
                {!feature && (
                  <div className=" mb-1 flex flex-row justify-between">
                    <div className="text-sm text-dark1 opacity-50">Form</div>
                  </div>
                )}
              </div>
              <div className={`flex flex-col ${feature ? "hidden" : ""}`}>
                <div className=" flex flex-row justify-between">
                  <div
                    className="text-sm text-dark1 opacity-50"
                    style={{ display: feature ? "none" : "" }}
                  >
                    Views
                  </div>
                  <div
                    className="text-sm text-dark1 opacity-50"
                    style={{ display: feature ? "none" : "" }}
                  >
                    Reward
                  </div>
                </div>
                <div className={"flex flex-row justify-between"}>
                  <div className="text-sm text-dark1">{campaign.pageView}</div>
                  <div className="text-sm text-dark1">
                    {reward?.toUpperCase()}
                  </div>
                </div>
              </div>
              {feature && (
                <div className="flex flex-row text-white text-xs">
                  <div>Views:&nbsp;</div>
                  <div>{campaign.pageView}</div>
                </div>
              )}

              {/* <div class="text-dark1 ">{element.symbol}</div> */}
            </div>
          </div>
        </div>
        <div
          className={`text-secondary flex items-center justify-center rounded-b-md bg-primary text-white py-1 ${
            feature ? "hidden" : ""
          }`}
        >
          Visit
        </div>
      </div>
    </Link>
  );
};
